{
  "Number": "Non",
  "Starttime": "Heure de début",
  "From": "De",
  "To": "A",
  "Duration": "Durée",
  "NAME": "CallRecording"
}